"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../../utils/validations");
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const StreamPartID_1 = require("../../../utils/StreamPartID");
class UnsubscribeRequest extends ControlMessage_1.default {
    constructor({ version = ControlMessage_1.default.LATEST_VERSION, requestId, streamId, streamPartition }) {
        super(version, ControlMessage_1.default.TYPES.UnsubscribeRequest, requestId);
        (0, validations_1.validateIsNotEmptyString)('streamId', streamId);
        (0, validations_1.validateIsNotNegativeInteger)('streamPartition', streamPartition);
        this.streamId = streamId;
        this.streamPartition = streamPartition;
    }
    getStreamPartID() {
        return (0, StreamPartID_1.toStreamPartID)(this.streamId, this.streamPartition);
    }
}
exports.default = UnsubscribeRequest;
//# sourceMappingURL=UnsubscribeRequest.js.map